import { render, staticRenderFns } from "./BackupAndRestore.vue?vue&type=template&id=1650f7ee&scoped=true&"
import script from "./BackupAndRestore.vue?vue&type=script&lang=ts&"
export * from "./BackupAndRestore.vue?vue&type=script&lang=ts&"
import style0 from "./BackupAndRestore.vue?vue&type=style&index=0&id=1650f7ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1650f7ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
